import { render, staticRenderFns } from "./editUser.vue?vue&type=template&id=6b0f0cba&scoped=true"
import script from "./editUser.vue?vue&type=script&lang=js"
export * from "./editUser.vue?vue&type=script&lang=js"
import style0 from "./editUser.vue?vue&type=style&index=0&id=6b0f0cba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0f0cba",
  null
  
)

export default component.exports